module.exports = __webpack_public_path__ + "img/loading.d877c966.svg";